<template>
  <card>
    <div class="row no-gutters">
      <div class="col-6">
        <div class="row no-gutters">
          <div class="col-12">
            <titles :text="$t('Zərər_vuran')"></titles>
            <hr class="section-divider">
          </div>
        </div>
        <div class="row no-gutters" style="color: var(--font-primary) !important; font-size: var(--font-large);;">
          <div :class="['col-4', textLeft, 'pd label']">{{ $t('S.A.A') }}</div>
          <div class="col-8 pd value">{{ item.personName ? item.personName : item.partPersonName }}</div>
          
          <div v-if="item.insuranceTypeName !== 'N/A'" :class="['col-4', textLeft, 'pd label']">{{ $t('Sığorta_növü') }}</div>
          <div v-if="item.insuranceTypeName !== 'N/A'" class="col-8 pd value">{{ item.insuranceTypeName }}</div>
          
          <div v-if="item.policyType && item.policyType === 1" :class="['col-4', textLeft, 'pd label']">{{ $t('Zərər_növü') }}</div>
          <div v-if="item.policyType && item.policyType === 1" class="col-8 pd value">{{ item.damageTypeName }}</div>
          
          <div v-if="item.policyType && item.policyType === 1" :class="['col-4', textLeft, 'pd label']">
            {{ item.damageType === 1 ? $t('NV_məlumat') : $t('Sənəd') }}
          </div>
          <div v-if="item.policyType && item.policyType === 1" class="col-8 pd value">
            <span>
              {{
                item.damageType === 1
                  ? formatInsVehicleInfo(item)
                  : formatInsPropertyInfo(item)
              }}
            </span>
          </div>
        </div>
      </div>
      
      <div class="col-6">
        <div class="row no-gutters">
          <div class="col-12">
            <titles :text="$t('Zərər_çəkən')"></titles>
            <hr class="section-divider">
          </div>
        </div>
        <div v-if="item.osId" class="row no-gutters" style="color: #65666a; font-size: var(--font-large);;">
          <div :class="['col-4', textLeft, 'pd label']">{{ $t('S.A.A') }}</div>
          <div class="col-8 pd value">{{ item.osPartPersonName }}</div>
          
          <div v-if="item.osInsuranceType" :class="['col-4', textLeft, 'pd label']">{{ $t('Sığorta_növü') }}</div>
          <div v-if="item.osInsuranceType" class="col-8 pd value">{{ item.osInsuranceTypeName }}</div>
          
          <div v-if="item.policyType && item.policyType === 1" :class="['col-4', textLeft, 'pd label']">{{ $t('Zərər_növü') }}</div>
          <div v-if="item.policyType && item.policyType === 1" class="col-8 pd value">{{ item.osDamageTypeName }}</div>
          
          <div v-if="item.policyType && item.policyType === 1" :class="['col-4', textLeft, 'pd label']">
            {{ item.osDamageType === 1 ? $t('NV_məlumat') : "" }}
          </div>
          <div v-if="item.policyType && item.policyType === 1" class="col-8 pd value">
            <span >
              {{
                item.osDamageType === 1
                  ? formatOsVehicleInfo(item.osRegNumber, item.osBrandModel)
                  : item.osDamageType === 3
                    ? formatOsPropertyInfo(item.osOtherPropertyName)
                    : ''
              }}
            </span>
          </div>
        </div>
        <div v-else class="no-data pd value">
          {{ $t('Yoxdur') }}
        </div>
      </div>
    </div>
  </card>
</template>
<script>
import Titles from './Titles.vue';
import { textLeft } from "../../services/helper";

export default {
  components: {
    Titles
  },
  props: {
    value: Object,
  },
  data() {
    return {
      item: this.value,
      textLeft: textLeft,
    };
  },
  watch: {
    value() {
      this.item = this.value;
    },
  },
  methods: {
    formatOsVehicleInfo(regNumber, brandModel) {
      let result = "";
      if (brandModel) result += brandModel;
      if (regNumber && brandModel) result += ", ";
      if (regNumber) result += regNumber;
      return result;
    },
    formatOsPropertyInfo(propertyName) {
      return propertyName ? ("Əmlak adı: " + propertyName) : "";
    },
    formatInsVehicleInfo(item) {
      let parts = [];
      if (item.brandModel) parts.push(item.brandModel);
      if (item.regNumber) parts.push(item.regNumber);
      return parts.join(", ");
    },
    formatInsPropertyInfo(item) {
      let parts = [];
      if (item.otherPropertyNumber) parts.push(item.otherPropertyNumber);
      if (item.otherProperty) parts.push(item.otherProperty);
      return parts.join(" / ");
    }
  }
};
</script>

<style lang="scss" scoped>
.no-gutters {
  margin-right: 0;
  margin-left: 0;
  
  > .col,
  > [class*="col-"] {
    padding-right: 0;
    padding-left: 0;
  }
}



.label {
  font-weight: bold;
  color:#3A3A3A !important;
 font-size: var(--font-primary);
}

.value {
  color: #333;
}

.info-text {
 font-size: var(--font-primary);
}

.section-divider {
  margin: 4px 0;
  height: 1px;
  background: #e0e0e0;
  border: none;
}

.no-data {
  color: #65666a;
font-size: var(--font-large);
  padding-left: 8px !important;
}
</style>